/* eslint-disable max-len */
import { Card } from '@mui/material';
import { type FC } from 'react';

interface Props {
  id: string;
}

export const LookerStudio: FC<Props> = ({ id }) => (
  <Card sx={{ height: '100%' }}>
    <iframe
      title="Looker Studio"
      width="100%"
      height="100%"
      src={`https://lookerstudio.google.com/embed/reporting/${id}`}
      sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
    />
  </Card>
);
